import { render, staticRenderFns } from "./Innovations.vue?vue&type=template&id=8165a6aa&"
import script from "./Innovations.vue?vue&type=script&lang=js&"
export * from "./Innovations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports